<template>
  <v-list class="multiple-devices-summary-message">
    <IconWithMessage
      color="success"
      icon="mdi-check-circle"
      :message="
        formatMessage(String($t('registerMultipleDevices.devicesRegistered')), registeredDevices)
      "
      data-cy="registeredDevices"
      :data-devices="registeredDevices"
    />
    <IconWithMessage
      color="error"
      icon="mdi-alert-circle"
      :message="failedFormattedMessage"
      data-cy="failedDevices"
      :data-devices="failedDevices"
    />
    <ErrorList v-if="showErrorList" :errors="errors" />
    <IconWithMessage
      v-if="showNotProcessedDevices"
      color="warning"
      icon="mdi-alert"
      :message="
        formatMessage(
          String($t('registerMultipleDevices.devicesNotProcessed')),
          notProcessedDevices
        )
      "
      data-cy="notProcessedDevices"
      :data-devices="notProcessedDevices"
    />
  </v-list>
</template>

<script lang="ts">
import { defineComponent, type PropType } from 'vue'
import ErrorList from './content/errorList.vue'
import IconWithMessage from './content/iconWithMessage.vue'

export default defineComponent({
  name: 'MultipleDevicesSummaryMessage',
  components: {
    ErrorList,
    IconWithMessage
  },
  props: {
    errors: Array as PropType<string[]>,
    registeredDevices: Number,
    failedDevices: Number,
    notProcessedDevices: Number
  },
  computed: {
    showErrorList(): boolean {
      return !!(this.errors && this.errors.length)
    },
    showNotProcessedDevices(): boolean {
      return !!((!this.registeredDevices && !this.failedDevices) || this.notProcessedDevices)
    },
    failedFormattedMessage(): string {
      const failedDevicesMessage = this.formatMessage(
        String(this.$t('registerMultipleDevices.devicesNotRegistered')),
        this.failedDevices
      )

      return this.failedDevices ? failedDevicesMessage : failedDevicesMessage.replace(':', '.')
    }
  },
  methods: {
    formatMessage(message: string, number?: number): string {
      return message.replace('/numberOfDevices/', String(number ?? 0))
    }
  }
})
</script>

<style lang="scss" scoped>
.error-list {
  padding-left: 2.5rem;
}
</style>
